export const en = {
    'popular-current-streams': 'Popular current streams',
    'title-streams': 'Streams',
    'no-streams': 'There aren\'t any active streams yet',
    'no-streams-description': 'A list of all streams available for you will be displayed here',
    'upcoming-streams': 'Upcoming streams',
};
